/*********************************************************
 *                  Admin gestion des abonnements
 ********************************************************/


"use strict";

angular.module("admin")
	.controller("AdminSubscriptionsCtrl", ["$scope", "toastr", "AdminService", "$uibModal", "Utils", "subscriptions", "products", "clients", function ($scope, toastr, AdminService, $uibModal, Utils, subscriptions, products, clients) {

		/******************
         * SETUP
         ******************/

		$scope.data = {
			subscriptions: subscriptions.data,
			products: products.data,
			clients: clients.data,
			newSubscription: {}
		};

		processSubscriptions($scope.data.subscriptions);


		//Création de la date de fin d'année
		var ladate = new Date();
		$scope.data.newSubscription.endDate = ladate.getFullYear() + "-12-31";

		//Date Année suivante
		$scope.data.dateRenouvellementAbo = (ladate.getFullYear() + 1) + "-12-30";


		/******************
         * SCOPE METHODS
         ******************/


		/**
         * Validation puis post du formulaire.
         */
		$scope.addSubscription = function () {
			if ($scope.data.newSubscription.selectedClient == undefined) {
				toastr.error("Veuillez renseigner l'entreprise à lier à ce nouvel abonnement.", "Création Abonnement");
				return;
			}
			if ($scope.data.newSubscription.selectedProduct == null) {
				toastr.error("Veuillez renseigner le service à lier à ce nouvel abonnement.", "Création Abonnement");
				return;
			}
			if ($scope.data.newSubscription.nbLicences == null) {
				toastr.error("Veuillez renseigner le nombre de licences pour cet abonnement.", "Création Abonnement");
				return;
			}
			if ($scope.data.newSubscription.endDate == undefined) {
				toastr.error("Veuillez renseigner une date de fin d'abonnement", "Création Abonnement");
				return;
			}


			AdminService.addSubscription($scope.data.newSubscription)
				.then(() => {
					toastr.success("", "Abonnement créé");
					AdminService.getAllSubscriptions()
						.then((response) => {
							processSubscriptions(response.data);
						})
						.catch((error) => {
							toastr.error(error.data.message, "Erreur");
						});
				})
				.catch(() => {
					toastr.error("Problème lors de la création de l'abonnement", "Création Abonnement");
				});

		};


		/**
         * Permet de griser les boutons lorsque l'abonnement est déjà souscrit.
         * @param product
         * @returns {boolean}
         */
		$scope.hasClientAlreadySubscribed = function (product) {
			if ($scope.data.newSubscription.selectedClient != undefined) {
				for (var productIndex in $scope.data.newSubscription.selectedClient.subscriptions) {
					var currentProduct = $scope.data.newSubscription.selectedClient.subscriptions[productIndex];
					if (currentProduct.product.id === product.id && currentProduct.state === "IN_USE") {
						return true;
					}
				}
			}
			return false;
		};


		/**
         * Cloturer un abonnement.
         *
         * @param numDossier
         */
		$scope.cloturerService = function (numDossier) {
			AdminService.closeSubscription(numDossier)
				.then(() => {
					toastr.success("", "Abonnement cloturé");
					AdminService.getAllSubscriptions()
						.then((response) => {
							let ensembleService = response.data;
							processSubscriptions(ensembleService);
							AdminService.getAllCompanyAdmins().then((response) => {
								$scope.data.companies = response.data;
							}).catch((error) => {
								toastr.error(error.data.message, "Erreur");
							});
						})
						.catch((error) => {
							toastr.error(error.data.message, "Erreur");
						});
				})
				.catch((error) => {
					toastr.error(error.data.message, "Erreur");
				});
		};

		/**
         * Renouveller un abonnement.
         *
         * @param numDossier id d'abonnement
         * @param dateRenouvellementAbo dat de renouvellement.
         */
		$scope.renouvelerAbonnement = function () {
			AdminService.modifySubscriptionEndDate($scope.data.currentSubscription.id, $scope.data.dateRenouvellementAbo)
				.then(() => {
					toastr.success("L'abonnement a été renouvelé", "Renouvellement d'Abonnement");
					//Relancer la récupération des données pour l'affichage de la liste des services
					AdminService.getAllSubscriptions().then((response) => {
						processSubscriptions(response.data);
						AdminService.getAllCompanyAdmins().then((response) => {
							$scope.data.companies = response.data;
						}).catch((error) => {
							toastr.error(error.data.message, "Erreur");
						});
					})
						.catch((error) => {
							toastr.error(error.data.message, "Erreur");
						});
				})
				.catch((error) => {
					toastr.error(error.data.message, "Renouvellement d'Abonnement");
				});
		};


		/**
         * Ouverture de la modale de renouvellement d'abonnement.
         *
         * @param subscription
         */
		$scope.renouvellementAbonnementModal = function (subscription) {
			$scope.data.currentSubscription = subscription;
			var renouvellementAbonnementModal = Utils.openModal($uibModal, "renouvellementAbonnementModal.html", $scope);
		};


		/******************
         * MISC
         ******************/

		function diffdate(d1, d2) {
			var WNbJours = d2.getTime() - d1.getTime();
			return Math.ceil(WNbJours / (1000 * 60 * 60 * 24));
		}


		/**
         * Calculs sur les abonnements pour affichage.
         * @param allSubscriptions
         */
		function processSubscriptions(allSubscriptions) {

			for (var i = allSubscriptions.length - 1; i >= 0; i--) {
				//Calcul de la différence entre les dates
				var Date2 = new Date(allSubscriptions[i].endDate);
				var Date1 = new Date();

				var diff = diffdate(Date1, Date2);
				if (allSubscriptions[i].state == "CLOSED") {
					//Ajout dans le JSON de la couleur de l'etat
					allSubscriptions[i].couleur = "black";
				}
				else if (diff > 10 && diff < 30) {
					//Ajout dans le JSON de la couleur de l'etat
					allSubscriptions[i].couleur = "rgb(249, 249, 13)";
				}
				else if (diff >= 0 && diff <= 10) {
					//Ajout dans le JSON de la couleur de l'etat
					allSubscriptions[i].couleur = "orange";
				}
				else if (diff < 0) {
					//Ajout dans le JSON de la couleur de l'etat
					allSubscriptions[i].couleur = "#c0392b";
				} else {
					//Ajout dans le JSON de la couleur de l'etat
					allSubscriptions[i].couleur = "#2ecc71";
				}
			}
            
			$scope.data.subscriptions = allSubscriptions;
		}


	}]);

